export default __webpack_public_path__ + "static/media/fa-brands-400.c1210e5e.woff2";